<script>
  import cityContacts from "@data/contacts.json";
  import CouncilMemberCard from "./CouncilMemberCard.svelte";

  const cityCountyDistrictMembers = cityContacts.filter(
    (contact) =>
      contact["Department"] === "City Council" &&
      contact["Position"].includes("District")
  );
</script>

{#each cityCountyDistrictMembers as member}
  <CouncilMemberCard {member} />
{/each}

<style>
</style>
